<script setup>
import { onMounted, ref } from 'vue'
import { cdnImageUrl } from '@dpgradio/creative'
import AnimatedSkewedEllipsMaskWithEnergeticFrequencies from './AnimatedSkewedEllipsMaskWithEnergeticFrequencies.vue'
import CharacterJumpFromTheRight from '../text_animations/CharacterJumpFromTheRight.vue'
const gsapTimeline = useGsapTimeline()

defineProps({
  position: String,
  dj: Object,
  containerClasses: String,
  positionClasses: String,
  nameClasses: String,
  imageContainerClasses: String,
  imageClasses: String,
})

const refElement = ref(null)
const timelineCount = ref(null)
const timelineImage = ref(null)

const emit = defineEmits(['timeline'])

onMounted(() => {
  emit('timeline', gsapTimeline({ name: 'ForbiddenWordDj' }).from(refElement, { x: '25%', opacity: 0, duration: 0.5 }).add(timelineCount, '<0.2').add(timelineImage, '<0.2'))
})
</script>

<template>
  <div ref="refElement" class="relative">
    <div :class="containerClasses" class="bg-white color-q-grey rounded-[2rem] font-bold tracking-[-3px] flex overflow-hidden">
      <div class="bg-q-cr-gray-primary inline-flex items-center" :class="positionClasses">
        <span class="py-2 pl-8 text-white">{{ Number(position) + 1 }}</span>
      </div>
      <div class="flex w-full justify-between">
        <div class="p-2 q-corner:pl-64 self-center ml-10" :class="nameClasses">{{ dj.firstName }}</div>
        <div class="px-10 self-center text-q-cr-red-primary">
          <CharacterJumpFromTheRight :text="dj.count + ' x'" textSizeClass="text-[1em]" textOutlineSizeClass="text-[1.6em]" @timeline="timelineCount = $event" />
        </div>
      </div>
    </div>
    <div :class="imageContainerClasses" class="absolute z-20">
      <AnimatedSkewedEllipsMaskWithEnergeticFrequencies :class="imageClasses" @timeline="timelineImage = $event">
        <img :src="cdnImageUrl(dj?.img)" class="w-full h-full object-cover" />
      </AnimatedSkewedEllipsMaskWithEnergeticFrequencies>
    </div>
  </div>
</template>
